
import { Alert, Snackbar } from '@mui/material';
import { createContext, useEffect, useState } from 'react';
import './Styles/App.css';
import RouteManager from './Router/RouteManager';
import { useLocation } from 'react-router-dom';
import CacheBuster from './Components/CacheBuster';
import { defaultTheme } from './themes';
export const ContextNotification = createContext();
export const severitys = { success: 'success', info: "info", warning: 'warning', error: 'error' }

function App() {
  const [open, setOpen] = useState({ IsEnable: false, Message: "", severity: severitys.success });
  const location = useLocation();
  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen({ IsEnable: false, Message: "", severity: severitys.success });
  };

  const clearCacheData = () => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
      console.log("Complete Cache Cleared")
    }
  };
  useEffect(() => {
    // clearCacheData();
  }, []);
  useEffect(() => {
    // clearCacheData();
  }, [location]);
  return (
    <div>
      <CacheBuster/>
    <div className="App">
      <Snackbar open={open.IsEnable} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={open.severity}
          variant="filled"
          sx={{ width: '100%',fontFamily:defaultTheme.typography.fontFamily }}
        >
          {open.Message}
        </Alert>
      </Snackbar>
      <ContextNotification.Provider value={{ open, setOpen }}>
        <RouteManager />
      </ContextNotification.Provider>
    </div>
    </div>
  );
}

export default App;